import { PriceRange } from '@immosky/types';
import { createAction, props } from '@ngrx/store';

export enum PriceActions {
  Reset = '[Filter] Reset Price Filter',
  Set = '[Filter] Set Price Filter',
  SetBasedOnValues = '[Filter] Set Price Filter Based On Values',
}

export const resetPriceFilter = createAction(PriceActions.Reset);

export const setPriceFilter = createAction(
  PriceActions.Set,
  props<{ filter: PriceRange }>()
);

export const setPriceFilterBasedOnUrlValues = createAction(
  PriceActions.SetBasedOnValues,
  props<{ values: { min: number; max: number } }>()
);
